import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import MyContext from "../../MyContext";
import { v4 as uuidv4 } from "uuid";
import { Formik } from "formik";
import axios from "axios";
import _ from "lodash";

// components
import { errorSwal, successUpdateSwal } from "../../helper/sweetalert";
import CustomButton from "../../components/CustomButton";
import { NumericFormat } from "react-number-format";
import { LINEAR_GRADIENT_BG, S3_URL, USER_KEY } from "../../const";

// apollo-clients
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GET_PRESIGN_URL } from "../../apollo/presignUrl/query";
import { UPDATE_PRODUCT } from "../../apollo/product/Mutation";
import { GET_CATEGORYS } from "../../apollo/category/query";
import { GET_SUBBRANDS } from "../../apollo/subbrand/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_BRANDS } from "../../apollo/brand/Query";
import { GET_UNITS } from "../../apollo/unit/Query";

// icons
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UpdateIcon from '@mui/icons-material/Update';
import { GrUpdate } from "react-icons/gr";

// react bootrap
import { Col, Form, Row, Spinner } from "react-bootstrap";

function EditProduct() {
  // state
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const history = useHistory();
  const Location = useLocation();
  const [category, setCategory] = useState();
  const [brand, setBrand] = useState();
  const [unit, setUnit] = useState();
  const [subBrand, setSubBrand] = useState();
  const [categoryname, setCategoryName] = useState();
  const [brandname, setBrandName] = useState();
  const [subBrandname, setSubBrandName] = useState();
  const [searchBrand, setSearchBrand] = useState();
  const [searchCategory, setSearchCategory] = useState();
  const [searchSubbrand, setSearchSubbrand] = useState();
  const [priceOptionFirst, setPriceOptionFirst] = useState();
  const [priceOptionSecond, setPriceOptionSecond] = useState();
  const [priceOptionThird, setPriceOptionThird] = useState();
  const [containOptionFirst, setContainOptionFirst] = useState();
  const [containOptionSecond, setContainOptionSecond] = useState();
  const [containOptionThird, setContainOptionThird] = useState();
  const [sortNumber, setSortNumber] = useState(0);
  const [isSize, setIsSize] = useState(Location?.state?.state?.size || '');
  const [file, setFile] = useState();
  const [isloading, setIsLoadding] = useState(false);
  const [imageLoading, setImageLoading] = useState(0);
  const [fileName, setFileName] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const [formDimension, setFormDimension] = useState({
      length: Location?.state?.state?.dimension?.length || '',
      width: Location?.state?.state?.dimension?.width || '',
      height: Location?.state?.state?.dimension?.height || '',
      weight: Location?.state?.state?.dimension?.weight || ''
    });

  // ============== > UseLazyQuery And UseMutaion <==============

  const [LoadCategory, { data: GetCategoryData }] =
    useLazyQuery(GET_CATEGORYS, { fetchPolicy: "network-only" });
  const [LoadBrand, { data: GetBrandData }] =
    useLazyQuery(GET_BRANDS, { fetchPolicy: "network-only" });

  const [LoadSubBrand, { data: GetSubBrandData }] =
    useLazyQuery(GET_SUBBRANDS, { fetchPolicy: "network-only" });

  const [LoadUnit, { data: GetUnitData }] = useLazyQuery(
    GET_UNITS,
    { fetchPolicy: "network-only" }
  );
  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);


  //============ update_product
  const [updateProduct, { loading: loadingUpdate }] =
    useMutation(UPDATE_PRODUCT);
  //============ update_product


  // ============== > useEffect <==============

  // console.log("Location===> ", Location)

  useEffect(() => {
    if (Location) {
      setIsLoadding(false);
      // setPriceoption1(Location?.state?.state?.priceOptions[0]?.price)
      setPriceOptionFirst(Location?.state?.state?.priceOptions[0]?.price ?? Location?.state?.price);
      // setPriceOptionFirst(Location?.state?.price ?? Location?.state?.state?.originPrice);
      setPriceOptionSecond(Location?.state?.state?.priceOptions[1]?.price);
      setPriceOptionThird(Location?.state?.state?.priceOptions[2]?.price);
      setContainOptionFirst(Location?.state?.state?.priceOptions[0]?.contain);
      setContainOptionSecond(Location?.state?.state?.priceOptions[1]?.contain);
      setContainOptionThird(Location?.state?.state?.priceOptions[2]?.contain);
      setCategoryName(Location?.state?.state?.category?.name);
      setBrandName(Location?.state?.state?.brand?.name);
      setSubBrandName(Location?.state?.state?.subbrand?.name);
      setSortNumber(Location?.state?.state?.sort);
      setFormDimension({
        length: Location?.state?.state?.dimension?.length,
        width: Location?.state?.state?.dimension?.width,
        height: Location?.state?.state?.dimension?.height,
        weight: Location?.state?.state?.dimension?.weight
      })
    } else {
      setIsLoadding(true);
    }
  }, []);

  useEffect(() => {
    _FecthUnitData();
  }, []);
  useEffect(() => {
    if (GetCategoryData) setCategory(GetCategoryData?.categories?.data);
  }, [GetCategoryData]);

  useEffect(() => {
    if (GetBrandData) setBrand(GetBrandData?.brands?.data);
  }, [GetBrandData]);

  useEffect(() => {
    if (GetSubBrandData) {
      const result = (GetSubBrandData?.subBrands?.data).sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setSubBrand(result);
    }
  }, [GetSubBrandData]);

  useEffect(() => {
    if (GetUnitData) setUnit(GetUnitData?.units?.data);
  }, [GetUnitData]);

  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  useEffect(() => {
    // TODO: Get all category
    LoadCategory({
      variables: {
        // limit: 800,
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
  }, []);

  useEffect(() => {
    filterBrand();
    filterSubBrand();
  }, [searchBrand, searchCategory, searchSubbrand]);

  // ============== > fuctions <==============

  const filterBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };
    if (searchCategory !== "") {
      _where = { ..._where, category: searchCategory };
    }

    // TODO: Get all brand
    LoadBrand({
      variables: {
        // limit: 800,
        where: _where,
      },
    });
  };

  const filterSubBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };
    if (searchBrand !== "") {
      _where = { ..._where, brand: searchBrand };
    }

    // TODO: Get all brand
    LoadSubBrand({
      variables: {
        // limit: 800,
        where: _where,
      },
    });
  };

  const generateNumberByDateTime = () => {
    const date = new Date();
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    const generatedNumber = year + month + day + hours + minutes + seconds;
    return generatedNumber.slice(-6);
  };

  const generatedNumber = generateNumberByDateTime();

  const _updateProduct = async (values) => {
    try {
      let priceOption = [
        {
          price: parseFloat(
            priceOptionFirst ? priceOptionFirst.toString().replace(/,/g, "") : 0
          ),
          contain: containOptionFirst
            ? containOptionFirst.toString().replace(/,/g, "")
            : "",
        },
        {
          price: parseFloat(
            priceOptionSecond
              ? priceOptionSecond.toString().replace(/,/g, "")
              : 0
          ),
          contain: containOptionSecond
            ? containOptionSecond.toString().replace(/,/g, "")
            : "",
        },
        {
          price: parseFloat(
            priceOptionThird ? priceOptionThird.toString().replace(/,/g, "") : 0
          ),
          contain: containOptionThird
            ? containOptionThird.toString().replace(/,/g, "")
            : "",
        },
      ];

      if (loadingUpdate) return;
      let dataUpdate = {
        ...values,
        size: isSize,
        priceOptions: priceOption,
        originAmount: values.amount,
        category: searchCategory,
        brand: searchBrand,
        subbrand: searchSubbrand,
        sort: parseInt(sortNumber) || 0,
        // amount: parseInt(amount ? amount.toString().replace(/,/g, "") : 0),
        price: priceOption[0]?.price,
        originPrice: parseFloat(
          values.price ? values?.price.toString().replace(/,/g, "") : 0
        ),
        dimension: {
          length: parseFloat(
            formDimension.length ? formDimension.length.toString().replace(/,/g, "") : 0
          ),
          width: parseFloat(
            formDimension.width ? formDimension.width.toString().replace(/,/g, "") : 0
          ),
          height: parseFloat(
            formDimension.height ? formDimension.height.toString().replace(/,/g, "") : 0
          ),
          weight: parseFloat(
            formDimension.weight ? formDimension.weight.toString().replace(/,/g, "") : 0
          ),
        },
      };

      let imagePayload = null;
      if (!_.isEmpty(fileName)) {
        imagePayload = [fileName];
      } else if (!_.isEmpty(Location?.state?.state?.image)) {
        imagePayload = Location?.state?.state?.image;
      }

      if (imagePayload) {
        dataUpdate = {
          ...dataUpdate,
          image: imagePayload,
        };
      }

      await updateProduct({
        variables: {
          where: {
            id: Location.state.state.id,
          },
          data: dataUpdate
        },
      });
      setFormDimension(null);
      successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      // history.goBack();
      history.push("/productlist/limit/50/page/1");
    } catch (err) {
      // errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      errorSwal("ພົບຂໍຜີດຜາດທີ່ບໍ່ຄາດຄີດ");
      console.log("error creating todo:", err);
    }
  };

  const _FecthUnitData = async () => {
    await LoadUnit({
      variables: {
        // limit: 500,
        where: {
          isDeleted: false,
          shop: shopId,
        },
      },
    });
  };

  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          borderRadius: 8,
          height: 300,
          width: 300,
        }}
      />
    );
  };

  const handleUpload = async (event) => {
    setImageLoading(0);

    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      // console.log("filename: ", filename)

      const pre = await getPresignUrl({
        variables: {
          name: filename,
        },
      });
      setFileName(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        const uploadfile = await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
        // console.log("uploadfile: ", uploadfile);
      }
    } catch (error) {
      console.log("ERROR: ", error);
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  // Dimension
  const handleChangeDimension = (e) => {
    const { name, value } = e.target;
    // Allow numbers with up to 2 decimal places and total length of 7 (4 digits + decimal point + 2 decimal places)
    if (value === '' || /^\d{0,4}(\.\d{0,2})?$/.test(value)) {
      setFormDimension(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        // shop: shopId,
        name: Location?.state?.state?.name,
        amount: Location?.state?.state?.amount,
        originAmount: Location?.state?.state?.originAmount,
        price: parseFloat(Location?.state?.state?.originPrice),
        image: Location?.state?.state?.image,
        currency: Location?.state?.state?.currency,
        detail: Location?.state?.state?.detail,
        // priceOptions: Location?.state?.state?.priceOptions,
        brand: Location?.state?.state?.brand?.id,
        subbrand: Location?.state?.state?.subbrand?.id,
        category: Location?.state?.state?.category?.id,
        unitId: Location?.state?.state?.unitId?.id,
        barCode: isChecked ? generatedNumber : Location?.state?.state?.barCode,
        size: Location?.state?.state?.size,
        shippingCost: Location?.state?.state?.shippingCost,
      }}
      validate={(values) => {
        // const errors = {};
        // if (!values.userId) {
        //     errors.userId = 'ກະລຸນາປ້ອນ Userid... !';
        // }
        // return errors;
      }}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        // console.log("onSubmit: ", values)
        _updateProduct(values);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        /* and other goodies */
      }) => (
        <>
          {/* {console.log("values=====>>>", values)
                        values.
                    } */}
          <div >
            {/* box head */}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "20px",
                backgroundColor: "#FFFFFF",
              }}>
              <span
                style={{ fontSize: "20px", color: "#6B7280" }}
                onClick={() => history.goBack()}>
                  <GrUpdate />
                {/* <ArrowBackIcon sx={{ fontSize: "23px", cursor: "pointer" }} /> */}
                &ensp;ແກ້ໄຂສິນຄ້າ
              </span>
              <span
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}>
                <CustomButton
                  height="42px"
                  borderRadius={5}
                  title={loadingUpdate ? <Spinner /> : "ອັບເດດ"}
                  width="149px"
                  background={LINEAR_GRADIENT_BG}
                  icon={loadingUpdate ? "" : <UpdateIcon />}
                  onClick={() => handleSubmit()}
                />
              </span>
            </div>

            {/* end box head */}

            <div
              style={{
                display: "flex",
                marginTop: "10px",
              }}>

              {/* box image */}
              <div
                style={{
                  width: "40%",
                  display: "flex",
                  alignItems: "start",
                  justifyContent: "center",
                  height:'100vh'
                }}>
                <div
                  // className="col-sm-3"
                  style={{ textAlign: "center" }}>
                  <input
                    type="file"
                    id="file-upload"
                    onChange={handleUpload}
                    hidden
                  />
                  <label htmlFor="file-upload">
                    <div
                      style={{
                        backgroundColor: "#F9FAFB",
                        height: "100%",
                        width: "100%",
                        border: "2px dashed #93989F",
                        borderRadius: 8,
                        cursor: "pointer",
                        display: "flex",
                        overflow:'hidden'

                      }}>
                      {file ? (
                        <ImageThumb image={file} />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            height: 300,
                            width: 300,
                            fontSize: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}>
                          {isloading ? (
                            <Spinner />
                          ) : (
                            <>
                            { Location?.state?.state?.image <= 0 ? (
                              <img style={{height:'100%', width:'100%'}} src="https://isjade.simplify.cool/images/no-image-2.jpg" />
                            ): (
                              <LazyLoadImage
                                src={S3_URL + values?.image}
                                style={{ objectFit: "contain" }}
                                width="100%"
                                height="100%"
                              />
                            )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </label>
                  {imageLoading ? (
                    <div className="progress" style={{ height: 20 }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${imageLoading}%`,
                          backgroundColor: "red",
                        }}
                        aria-valuenow={imageLoading}
                        aria-valuemin="0"
                        aria-valuemax="100">
                        {imageLoading}%
                      </div>
                    </div>
                  ) : (
                    <div style={{ height: 20 }} />
                  )}
                </div>
              </div>

              {/* end box image */}

              <div
                style={{
                  // backgroundColor: 'blue',
                  width: "100%",
                  padding:20,
                  background:"#fff"
                }}>
                <Row>
                  <Col>
                    <Form.Label>ຊື່ສິນຄ້າ</Form.Label>
                    <Form.Control
                      name="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      placeholder="ຊື່ສິ້ນຄ້າ..."
                    />
                  </Col>

                  {isChecked ? (
                    <Col>
                      <Form.Label>ລະຫັດບາໂຄດອໍໂຕ້</Form.Label>
                      <Form.Control
                        name="barCode"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={generatedNumber}
                        placeholder="ລະຫັດ barCode..."
                      // value={values.barCode}
                      />
                    </Col>
                  ) : (
                    <Col>
                      <Form.Label>ລະຫັດບາໂຄດ</Form.Label>
                      <Form.Control
                        name="barCode"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="ລະຫັດ barCode..."
                        value={values.barCode}
                      />
                    </Col>
                  )}
                  <Col>
                    <Form.Label style={{ color: "white" }}>.</Form.Label>
                    <Form.Check
                      value={isChecked}
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      type="switch"
                      id="custom-switch"
                      label="ລະຫັດບາໂຄດອໍໂຕ້"
                      size={100}
                    />
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col className="col-6">
                    <Form.Label>ປະເພດສິນຄ້າ</Form.Label>
                    <Form.Control
                      as="select"
                      name="category"
                      onChange={(e) => {
                        setSearchCategory(e.target.value);
                      }}
                      // onBlur={handleBlur}
                      value={searchCategory}>
                      <option
                        value={values.category}
                        selected
                        style={{ display: "none" }}>
                        {categoryname}
                      </option>
                      <option value="ALL">ທັງໝົດ</option>
                      {category?.map((cat, index) => (
                        <>
                          <option key={cat + index} value={cat?.id}>
                            {cat?.name}
                          </option>
                        </>
                      ))}
                    </Form.Control>
                  </Col>
                  <Col className="col-3">
                    <Form.Label>ແບນສິນຄ້າ</Form.Label>
                    { _.isEmpty(brand) ? (
                      <p>ບໍ່ມີແບນສີ້ນຄ້າ</p>
                    ) : (
                      <Form.Select
                        name="brand"
                        onChange={(e) => {
                          setSearchBrand(e.target.value);
                        }}
                        value={searchBrand}
                      // defaultValue={values.subbrand}
                      >
                        <option
                          value={values.brand}
                          selected
                          style={{ display: "none" }}>
                          {brandname}
                        </option>
                        {/* <option value="ALL">ທັງໝົດ</option> */}
                        {brand?.map((brands, index) => (
                            <option key={brands + index} value={brands?.id}>
                              {brands?.name}
                            </option>
                          ))
                        }
                      </Form.Select>
                    )}
                  </Col>
                  <Col className="col-3">
                    <Form.Label>ຊັບແບນສິນຄ້າ</Form.Label>
                    {_.isEmpty(subBrand) ? (
                      <p>ບໍ່ມີຊັບແບນສີ້ນຄ້າ</p>
                    ) : (
                      <Form.Select
                        name="brand"
                        onChange={(e) => {
                          setSearchSubbrand(e.target.value);
                        }}
                        // onBlur={handleBlur}
                        value={searchSubbrand}>
                        <option
                          value={values.subbrand}
                          selected
                          style={{ display: "none" }}>
                          {!subBrandname ? "ຍັງບໍ່ມີ" : brandname}
                        </option>
                        <option value="ALL">ທັງໝົດ</option>
                        {subBrand?.map((sub, index) => (
                          <option key={sub + index} value={sub?.id}>
                            {sub?.name}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col className="col-3">
                    <Form.Label>ຈຳນວນສິນຄ້າ</Form.Label>
                    <Form.Control
                      name="amount"
                      type="number"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.amount}
                      placeholder="ຈຳນວນສິນຄ້າ..."
                      />
                  </Col>
                  <Col className="col-6">
                    <Form.Label>ຄ່າຈັດສົ່ງ</Form.Label>
                    <Form.Control
                      name="shippingCost"
                      type="number"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.shippingCost}
                      placeholder="ຄ່າຈັດສົ່ງ..."
                    />
                  </Col>
                  <Col>
                    <Form.Label>ຫົວໜ່ວຍສິນຄ້າ</Form.Label>
                    <Form.Select
                      name="unitId"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.unitId}>
                      {unit?.map((unitss, index) => (
                        <option key={unitss + index} value={unitss?.id}>
                          {unitss?.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Form.Label>ລາຄາຊື້ສິນຄ້າ</Form.Label>
                    <NumericFormat
                      name="price"
                      min={0}
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.price}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>

                  <Col>
                    <Form.Label>ສະກຸນເງີນ</Form.Label>
                    <Form.Select
                      name="currency"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.currency}>
                      <option value="LAK">ກີບ</option>
                      <option value="BAHT">ບາດ</option>
                      <option value="USD">ໂດລາ</option>
                    </Form.Select>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Form.Label>ລາຄາຂາຍ 1</Form.Label>
                    <NumericFormat
                      name="priceOptionFirst"
                      min={0}
                      className="form-control"
                      onChange={(e) => setPriceOptionFirst(e.target.value)}
                      placeholder="ລາຄາຂາຍສິ້ນຄ້າ"
                      value={priceOptionFirst}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>

                  <Col>
                    <Form.Label>ບັນຈຸ 1</Form.Label>
                    <NumericFormat
                      name="containOptionFirst"
                      min={0}
                      className="form-control"
                      onChange={(e) => setContainOptionFirst(e.target.value)}
                      placeholder="ບັນຈຸ..."
                      value={containOptionFirst}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Form.Label>ລາຄາຂາຍ 2</Form.Label>
                    <NumericFormat
                      name="priceOptionSecond"
                      min={0}
                      className="form-control"
                      onChange={(e) => setPriceOptionSecond(e.target.value)}
                      placeholder="ລາຄາຂາຍສິ້ນຄ້າ"
                      value={priceOptionSecond}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                  <Col>
                    <Form.Label>ບັນຈຸ 2</Form.Label>
                    <NumericFormat
                      name="containOptionSecond"
                      min={0}
                      className="form-control"
                      onChange={(e) => setContainOptionSecond(e.target.value)}
                      placeholder="ບັນຈຸ..."
                      value={containOptionSecond}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Form.Label>ລາຄາຂາຍສົ່ງ</Form.Label>
                    <NumericFormat
                      name="priceOptionThird"
                      min={0}
                      className="form-control"
                      onChange={(e) => setPriceOptionThird(e.target.value)}
                      placeholder="ລາຄາຂາຍສິ້ນຄ້າ"
                      value={priceOptionThird}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                  <Col>
                    <Form.Label>ບັນຈຸ 3</Form.Label>
                    <NumericFormat
                      name="containOptionThird"
                      min={0}
                      className="form-control"
                      onChange={(e) => setContainOptionThird(e.target.value)}
                      placeholder="ບັນຈຸ..."
                      value={containOptionThird}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                    <Form.Label>ເລກຈັດລຽງສະແດງສິນຄ້າ</Form.Label>
                    <NumericFormat
                      name="containOptionThird"
                      min={0}
                      className="form-control"
                      onChange={(e) => setSortNumber(e.target.value)}
                      placeholder="ເລກຈັດລຽງ..."
                      value={sortNumber}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                  <Col>
                    <Form.Label>ຂະຫນາດສີນຄ້າ</Form.Label>
                    <Form.Control
                        type="size"
                        value={isSize}
                        onChange={(e) => setIsSize(e.target.value)}
                        placeholder="ຂະຫນາດສີນຄ້າ..."
                      />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col> {/* Length */}
                    <Form.Label>ລວງຍາວ(cm)</Form.Label>
                    <Form.Control
                        type="number"
                        step="0.01"
                        name="length"
                        value={formDimension.length}
                        onChange={handleChangeDimension}
                        placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                      />
                    <Form.Control.Feedback type="invalid">
                      {errors.length}
                    </Form.Control.Feedback>
                  </Col>
                  <Col> {/* Width */}
                    <Form.Label>ລວງກ້ວາງ(cm)</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      name="width"
                      value={formDimension.width}
                      onChange={handleChangeDimension}
                      placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.width}
                    </Form.Control.Feedback>
                  </Col>
                  <Col> {/* Height */}
                    <Form.Label>ລວງສູງ(cm)</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      name="height"
                      value={formDimension.height}
                      onChange={handleChangeDimension}
                      placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                      aria-label="Length input"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.height}
                    </Form.Control.Feedback>
                  </Col>
                  <Col> {/* Weight */}
                    <Form.Label>ນ້ຳຫນັກ(kg)</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      name="weight"
                      value={formDimension.weight}
                      onChange={handleChangeDimension}
                      placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.weight}
                    </Form.Control.Feedback>
                  </Col>
                </Row>

                <Row>
                  <Col>
                  
                  <Form.Label>ລາຍລະອຽດເພີ່ມເຕີມ</Form.Label>
              <Form.Control
                as="textarea"
                name="detail"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.detail}
                placeholder="ລາຍລະອຽດເພີ່ເຕີ່ມ..."
                style={{ height: "100px" }}
              />
              
              </Col>
                </Row>



              </div>
            </div>
          </div>
        </>
      )}
    </Formik>
  );
}

export default EditProduct;
